import { createReducer, on } from '@ngrx/store';
import * as userActions from '../actions/login.actions';
import { UserState } from '../UserState';

export const initialState: UserState = {
  user: null,
  role: null,
};

export const loginReducer = createReducer(
  initialState,
  on(userActions.loginSuccess, (state, user) => ({
    ...state,
    user,
    role: {
      role: user.current_role,
      isAdmin: user.current_role === 'admin',
      isAccountant: user.current_role === 'accountant',
      isPartner: user.current_role === 'partner',
      isAffiliate: user.current_role === 'affiliate',
      isCustomer: user.current_role === 'customer',
    }
  })),
  on(userActions.roleUpdated, (state, newRole) => ({...state,
    role: {
      role: newRole.role,
      isAdmin: newRole.role === 'admin',
      isAccountant: newRole.role === 'accountant',
      isPartner: newRole.role === 'partner',
      isAffiliate: newRole.role === 'affiliate',
      isCustomer: newRole.role === 'customer',
    }
  }))
);
